import { createSlice } from "@reduxjs/toolkit";
import { IMasterState } from "./types";

const initialState: IMasterState = {
  rfqList: null,
  quoteDetails: null,
  rfqRoundsList: null,
};

const rfqSlice = createSlice({
  name: "rfqSlice",
  initialState,
  reducers: {
    setRFQList: (state, action) => {
      const payload = action.payload;

      if (payload?.result) {
        state.rfqList = payload.result;
        return;
      }

      if (Array.isArray(payload?.data)) {
        state.rfqList = {
          data: payload.data,
          total: payload.total ?? payload.count ?? payload.data.length,
        };
        return;
      }

      if (Array.isArray(payload?.results)) {
        state.rfqList = {
          data: payload.results,
          total: payload.total ?? payload.count ?? payload.results.length,
        };
        return;
      }

      if (Array.isArray(payload)) {
        state.rfqList = {
          data: payload,
          total: payload.length,
        };
        return;
      }

      state.rfqList = null;
    },
    setQuoteDetails: (state, action) => {
      state.quoteDetails = action.payload;
    },
    setRFQRoundsList: (state, action) => {
      state.rfqRoundsList = action.payload;
    },
  },
});

export const { setRFQList, setQuoteDetails, setRFQRoundsList } = rfqSlice.actions;
export default rfqSlice.reducer;
